<section class="p-0 flex flex-col gap-6">
  <section class="p-0" aria-labelledby="page-headline">
    <h1 id="page-headline" class="mu-heading-5 text-petrol-650 pb-2">
      Information zur Zusatz-Software
    </h1>
    <p>Hier finden Sie folgende Downloads:</p>
    <ul class="list-inside list-disc pl-3">
      <li>Service-Releases</li>
      <li>Unterstützende Tools</li>
      <li>Musterpakete</li>
      <li>Tabellen</li>
    </ul>
  </section>

  <mat-divider aria-hidden="true"></mat-divider>

  <section class="p-0" *ngrxLet="selectedDownload$ as selectedDownload">
    @if (showProductGroupFilter$ | ngrxPush) {
      <search
        aria-label="Zusatz-Software Suche"
        class="flex flex-col sm:flex-row pb-2 gap-4"
      >
        <div class="max-w-fit">
          <dackl-filter-single-select
            label="Produktgruppe"
            [selections]="productGroups"
            (selectedValueChange)="filterProductGroup($event)"
            showItemSearch
            resettable
          ></dackl-filter-single-select>
        </div>
        <dackl-instant-apply-search
          (searchStringChanged)="filterProductName($event)"
          label="Programmname suchen"
          placeholder="Suchen"
          ariaLabelClearSearch="Suche nach Programmname zurücksetzen"
        ></dackl-instant-apply-search>
      </search>
    }

    <dp-downloads-table
      [dataSource]="productDataSource"
      [tableAriaLabel]="'Downloads Zusatz-Software'"
      [selectedDownload]="selectedDownload"
      [showLoadMoreButton]="!allDataLoaded"
      (onRowSelection)="handleTableRowSelection($event)"
      (onLoadMoreButtonClick)="loadMoreData()"
      (onErrorReloadButtonClick)="reloadSite()"
    ></dp-downloads-table>
  </section>
</section>
